import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { instrumentationKey } from '@utils/AppInsights/connectionString';
import { getToken, getUser } from '@utils/tokenStorage';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import { Routing } from './routing';
import { getStore, history } from './store/configureStore';
import Global from './styles/global';

const token = getToken();
const user = getUser();
const initialState = { auth: { token, email: user } };

export const store = getStore(initialState);

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: instrumentationKey,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history },
    },
  },
});

let initialized = false;

if (!initialized) {
  appInsights.loadAppInsights();
  initialized = true;
}

const TrackedApp = withAITracking(reactPlugin, () => (
  <HelmetProvider>
    <Global />
    <Provider store={store}>
      <Routing />
    </Provider>
  </HelmetProvider>
));

const App = ({ isCustomDomain, username }) => <TrackedApp isCustomDomain={isCustomDomain} username={username} />;

// const App = () => (
//   <>
//     <Global />
//     <Provider store={store}>
//       <Routing />
//     </Provider>
//   </>
// );

export default App;
